import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tinge-close",
  "use": "icon-tinge-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-tinge-close\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" opacity=\".01\" /><path fill=\"currentColor\" fill-opacity=\".45\" fill-rule=\"evenodd\" d=\"M2.706 2 2 2.706 7.294 8 2 13.294l.706.706L8 8.706 13.294 14l.706-.706L8.706 8 14 2.706 13.294 2 8 7.294z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol